<template>
  <transition-group name="fade" mode="out-in">
    <!-- v-if="false && !user.emailVerified" -->

    <div :key="'check-email'" class="bg-white p-3 p-md-4" v-if="false">
      <img
        :src="require('@/assets/img/email.png')"
        alt="Check email"
        class="mb-5"
      />
      <h2>Email verification has been sent! fdsa</h2>
      <p>Please check your inbox and verify your email address</p>
    </div>
    <!-- Verified and already have notes -->
    <div v-else-if="metadata" :key="'dash'">
      <div class="d-flex row no-gutters" v-if="filteredNotes.length">
        <div
          class="dash-sidenav col-md-3 text-left bg-dark-blue text-white p-3 p-md-4 flex-stretch"
        >
          <!-- <button @click="syncNoteSummaries">Sync notes</button> -->
          <h3 class="mb-3">Categories</h3>
          <ul>
            <li @click="resetFilter">All</li>
            <li
              v-for="category in categories"
              :key="category"
              class="font-weight-bold"
            >
              <div @click="selectCategory(category)" class="mb-2">
                {{ category }}
              </div>

              <!-- <ul>
                <li
                  v-for="note in category.notes"
                  :key="note.noteId"
                  @click.prevent="selectNote(note.noteId)"
                >
                  {{ note.title || "No title" }}
                </li>
              </ul> -->
            </li>
          </ul>
        </div>
        <div class="col-md-9 p-3 p-md-4 bg-white flex-stretch">
          <h2 class="mb-3">{{ filterByLabel || "Recent Notes" }}</h2>
          <ul
            class="notes d-flex flex-column-reverse pl-0"
            v-if="filteredNotes.length"
          >
            <li
              @click.prevent="selectNote(note)"
              v-for="note in filteredNotes"
              :key="note.id"
              class="note-item mb-3 text-left p-2"
            >
              <div class="d-flex">
                <div class="flex-fill flex-stretch">
                  <p class="mb-0">{{ note.title ? note.title : "No title" }}</p>
                  <!-- <small class="text-secondary">
                    {{ formatDate(note.createdAt) }}</small
                  > -->
                </div>
                <div class="menu flex-stretch align-items-center small">
                  <delete-button :id="note.noteId"></delete-button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <base-pagination
          :value="currentPage"
          :total="metadata.notesCount"
          :perPage="notesPerPage"
          @input="updatePage"
          align="center"
        ></base-pagination> -->
      </div>

      <!-- Verified, no note yet -->
      <div v-else class="bg-white p-3 p-md-5">
        <img
          :src="require('@/assets/img/welcome.png')"
          alt="Check email"
          class="mb-5"
        />
        <h2>Welcome to SHINKA+NOTE!</h2>
        <p>Let's start writing!</p>
        <button @click="tryCreateNote" class="btn-dark-blue mt-4">
          Create your first note
        </button>
      </div>
    </div>
    <div
      v-else
      :key="'bookloader'"
      class="bookloader-contaier w-100 d-flex justify-content-center align-content-center"
    >
      <book-loader class="align-self-center" />
    </div>
  </transition-group>
</template>

<script>
import DeleteButton from "@/components/buttons/DeleteButton.vue";

import { mapGetters, mapActions } from "vuex";
import DateTime from "luxon/src/datetime.js";
import BookLoader from "../components/loader/BookLoader.vue";

export default {
  name: "Dashboard",
  components: {
    DeleteButton,
    BookLoader
  },
  data() {
    return {
      currentPage: 1,
      notesPerPage: 100,
      gotNotes: false,
      filterByLabel: "Recent",
      filterByType: null,
      filterByValue: null
    };
  },
  computed: {
    ...mapGetters({
      notes: "getNotes",
      user: "getUser",
      metadata: "getMetadata",
      categories: "getCategories"
    }),

    filteredNotes() {
      const filteredNotes = this.metadata.noteSummaries.filter(note => {
        if (this.filterByType === null) {
          return true;
        }
        if (this.filterByType === "category") {
          return note.category === this.filterByValue;
        }
        if (this.filterByType === "CreatedAt") {
          return note.created === this.filterByValue;
        }
      });
      return filteredNotes;
    }
  },
  methods: {
    ...mapActions({
      createNote: "createNote",
      fetchUserMetadata: "fetchUserMetadata"
    }),
    formatDate(timestamp) {
      return DateTime.fromSeconds(timestamp.seconds).toFormat("DDD");
    },
    async tryCreateNote() {
      const id = await this.createNote();
      this.$router.push("/note/" + id);
    },
    selectNote(note) {
      console.log(note);
      this.$router.push({ name: "Note", params: { id: note.noteId } });
    },
    updatePage(page) {
      this.currentPage = page;
    },
    selectCategory(category) {
      this.filterByType = "category";
      this.filterByValue = category;
      this.filterByLabel = `Category: ${category}`;
    },
    resetFilter() {
      this.filterByType = null;
      this.filterByValue = null;
      this.filterByLabel = "All Categories";
    }
  },
  async mounted() {
    this.unsubscribe = await this.fetchUserMetadata(this.user.uid);
    console.log(this.unsubscribe);
    this.gotNotes = true;
  },
  async beforeDestroy() {
    this.unsubscribe();
    console.log("unsubscribe");
  }
};
</script>

<style lang="scss" scoped>
.bookloader-contaier {
  min-height: 70vh;
}
.dash-sidenav {
  ul {
    padding-left: 0;
    li {
      list-style: none;
      cursor: pointer;
      margin-bottom: 0.5rem;
      line-height: 1.3em;
      ul {
        padding-left: 1rem;
      }
    }
  }
}
.note-item {
  list-style: none;
  cursor: pointer;
  .menu {
    display: none;
    a {
      color: $mediumGrey;
      padding: 0 0.5rem;
      &:hover {
        color: $darkGrey;
      }
    }
  }
  &:hover {
    background: $lightGrey;
    // border-radius: $border-small-radius;
    .menu {
      display: flex;
    }
  }
}
</style>
